<template>
  <div class="sentiment-analysis">
    <div class="flex-align-center" style="margin-bottom: 20px">
      <img
        src="@/assets/imgs/school/monthRecord/exponent.png"
        alt=""
        style="width: 24px; height: 22px; margin-right: 5px"
      />
      <div class="record-title">情绪指数分析</div>
    </div>
    <!--全校情绪指数走势折线图-->
    <AnalyseLineChart
      title="全校情绪指数走势"
      :dateRange="dateRange"
      :dataSource="sentimentLine.lineData"
      :fields="sentimentLine.filedList"
      :analyseList="allSchoolAnalyseList"
    />
    <!--全校关爱名单情绪指数折线图-->
    <!-- <AnalyseLineChart
      title="全校关爱名单情绪走势"
      :dataSource="careSentimentLine.lineData"
      :fields="careSentimentLine.filedList"
      :analyseList="careListAnalyseList"
      style="margin-top: 30px"
    /> -->
    <!--排名列表-->
    <div class="rank-card flex-between">
      <ClassEmotionRank
        title="各年级情绪指数最高的3个班级（top3）"
        :dataSource="ascRankList"
        :loading="ascLoading"
        :pagination="ascPagination"
        class="rank-card-item"
        @pageChange="handleAscPageChange"
      />
      <ClassEmotionRank
        title="各年级情绪指数最低的3个班级（top3）"
        :dataSource="descRankList"
        :loading="descLoading"
        :pagination="descPagination"
        class="rank-card-item"
        @pageChange="handleDescPageChange"
      />
    </div>
   
  
  </div>
</template>
<script>
import CountAnimation from '@/components/CountAnimation'
import AnalyseLineChart from './components/AnalyseLineChart.vue'
import ClassEmotionRank from './components/ClassEmotionRank.vue'
import {
  schoolMoodTrend,
  queryCareStudentAvgEmotionByTime,
  queryAllGradeEmotionByTime,
  queryGradeAvgEmotionByTime,
  getTop3ClassesByEmotion,
  getBottom3EmotionClassesPerGrade,
} from '@/api/monthReport'
import { handleLineChartData } from '@/utils/util'
import LineChart from '@comp/echartZyz/components/LineChart.vue'

export default {
  name: 'SentimentAnalysis',
  components: {
    LineChart,
    CountAnimation,
    AnalyseLineChart,
    ClassEmotionRank
  },
  props: {
    dateRange: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      sentimentLine: {},
      careSentimentLine: {},
      allSchoolAnalyseList: [],
      careListAnalyseList: [],
      ascRankList: [],
      descRankList: [],
      ascLoading: false,
      descLoading: false,
      // 排名表格分页参数（pageNo / pageSize 发请求时携带）
      ascPagination: { current: 1, pageSize: 10, total: 0 },
      descPagination: { current: 1, pageSize: 10, total: 0 },
      // 当前查询时间区间
      dateParams: {},
    }
  },
  created() {},
  watch: {
    dateRange(dateObj) {
      const formatDateObj = {
        startTime: dateObj.beginDate,
        endTime: dateObj.endDate,
      }
      this.dateParams = formatDateObj
      // 时间区间变化后排名列表回到第一页
      this.ascPagination = { ...this.ascPagination, current: 1 }
      this.descPagination = { ...this.descPagination, current: 1 }
      this.queryAllGradeEmotionByTime(formatDateObj)
      this.queryGradeAvgEmotionByTime(formatDateObj)
      this.schoolMoodTrend(dateObj)
      this.queryCareStudentAvgEmotionByTime(formatDateObj)
      this.queryTop3ClassesByEmotion()
      this.queryBottom3EmotionClasses()
    },
  },
  methods: {
    // 全校指数折线图
    async queryAllGradeEmotionByTime(dateObj) {
      const { success, result } = await queryAllGradeEmotionByTime(dateObj)
      if (success) {
        this.sentimentLine = handleLineChartData(result)
      }
    },
    // 全校情绪指数趋势分析文本
    async queryGradeAvgEmotionByTime(dateObj) {
      const { success, result } = await queryGradeAvgEmotionByTime(dateObj)
      if (success) {
        this.allSchoolAnalyseList = result
      }
    },
    // 全校关爱名单指数折线图
    async schoolMoodTrend(dateObj) {
      const { success, result } = await schoolMoodTrend(dateObj)
      if (success) {
        // const { lineData, filedList } = handleLineChartData(result)
        this.careSentimentLine = handleLineChartData(result)
      }
    },
    // 全校关爱名单指数趋势分析文本
    async queryCareStudentAvgEmotionByTime(dateObj) {
      const { success, result } = await queryCareStudentAvgEmotionByTime(dateObj)
      if (success) {
        this.careListAnalyseList = result
      }
    },
    // 各年级情绪指数最高的3个班级
    async queryTop3ClassesByEmotion() {
      this.ascLoading = true
      try {
        const { success, result } = await getTop3ClassesByEmotion({
          ...this.dateParams,
          pageNo: this.ascPagination.current,
          pageSize: this.ascPagination.pageSize,
        })
        if (success) {
          const records = (result && result.records) || []
          // 接口字段 emotionIndex → 表格列 avgValue
          this.ascRankList = records.map((item) => ({
            gradeName: item.gradeName,
            className: item.className,
            avgValue: item.emotionIndex,
            diffValue: item.diffValue,
            diffText: item.diffText,
          }))
          // 同步后端返回的总条数（pageNo / pageSize 以用户选择为准）
          this.ascPagination = {
            ...this.ascPagination,
            total: Number(result && result.total) || 0,
          }
        }
      } finally {
        this.ascLoading = false
      }
    },
    // 各年级情绪指数最低的3个班级
    async queryBottom3EmotionClasses() {
      this.descLoading = true
      try {
        const { success, result } = await getBottom3EmotionClassesPerGrade({
          ...this.dateParams,
          pageNo: this.descPagination.current,
          pageSize: this.descPagination.pageSize,
        })
        if (success) {
          // 注意：该接口返回的是年级维度（schoolAvgEmotion + gradeList），没有班级明细，走前端分页
          const records = (result && result.records) || []
          this.descRankList = records.map((item) => ({
            gradeName: item.gradeName,
            className: item.className,
            avgValue: item.emotionIndex,
            diffValue: item.diffValue,
            diffText: item.diffText,
          }))
          // 同步后端返回的总条数（pageNo / pageSize 以用户选择为准）
          this.descPagination = {
            ...this.descPagination,
            total: Number(result && result.total) || 0,
          }
        }
      } finally {
        this.descLoading = false
      }
    },
    // 最高情绪指数排名分页变化
    handleAscPageChange({ pageNo, pageSize }) {
      this.ascPagination = { ...this.ascPagination, current: pageNo, pageSize }
      this.queryTop3ClassesByEmotion()
    },
    // 最低情绪指数排名分页变化
    handleDescPageChange({ pageNo, pageSize }) {
      this.descPagination = { ...this.descPagination, current: pageNo, pageSize }
      this.queryBottom3EmotionClasses()
    },
  },
}
</script>
<style scoped lang="less">
.sentiment-analysis {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  .rank-card {
    align-items: stretch !important;
    margin-top: 20px;
    .rank-card-item {
      width: calc(50% - 15px);
    }
  }
  // 变化幅度箭头颜色（卡片列表与弹框共用）
  .diff-up {
    color: #3ba1f5;
    font-weight: 500;
  }
  .diff-down {
    color: #9254de;
    font-weight: 500;
  }
}
</style>
